import { gql } from '@apollo/client';

export const SALESFORCE_ACCOUNTS_PAGE_SIZE = 20;

export const GET_SALESFORCE_ACCOUNTS = gql`
  query getSalesforceAccounts($filter: SalesforceAccountFilter)
  @api(name: treatmentMonitor) {
    getSalesforceAccounts(filter: $filter) {
      accounts {
        id
        name
        email
        personMobilePhone
        ownerName
      }
      hasNext
    }
  }
`;

export const GET_SALESFORCE_ACCOUNT_BY_ID = gql`
  query getSalesforceAccountById($id: ID!) @api(name: treatmentMonitor) {
    getSalesforceAccountById(id: $id) {
      accountNumber
      activeZenyumProOpportunities
      aftersalesDateOfFitting
      afterSalesOpportunityId
      afterSalesOpportunityName
      ageCategoryPc
      agePc
      anchorDoctorPc
      appCustomerName
      appLastVisitDateAndTime
      appRegisteredDateAndTime
      autoInternalTpvApprovalPc
      billingAddress
      billingCity
      billingCountry
      billingCountryCode
      billingGeocodeAccuracy
      billingLatitude
      billingLongitude
      billingPostalCode
      billingStreet
      canPrescribeZenclearPlusPc
      clinic
      clinicAddressForeignLanguagePc
      clinicAddressPc
      clinicCloudUserId
      clinicCloudUserName
      clinicConsultationFeePc
      clinicFeeForWhiteningExisting
      clinicNamePc
      clinicReferralCommissionForAligner
      clinicReferralCommissionForWhitening
      clinicType
      consultationFeeRefinement
      convertedLeadId
      createdBy
      createdDate
      csCommentsPc
      csManagerCommentsPc
      currencyIsoCode
      currentTreatment
      dateOfConsultationReadOnlyPc
      dateOfFittingReadOnlyPc
      deliveryToClinic
      demoAccountPc
      dentistOffboardedDateTimePc
      dentistTenurePc
      doctorTrainingExamPassedPc
      doctorTypePc
      doNotEmailPc
      email
      excludeOffboardingEmail
      expiryDate
      facebookPc
      fax
      firstName
      flightPathSalesOptInPc
      flowDoctorReferralOnlyPc
      goodQualityOfInputPc
      guardianEmailAddress
      guardianFullName
      guardianPhoneNumber
      guardianWhatsappNumber
      haveInformedGuardian
      id
      influencerTier
      instagramPc
      intercomIdPc
      invisibleBracesConcernPc
      isPartner
      isPersonAccount
      languagePc
      lastActivityDate
      lastContactedMode
      lastContactedTime
      lastCreatedOpportunityId
      lastCreatedOpportunityName
      lastDoctorTrainingExamScorePc
      lastModifiedBy
      lastModifiedDate
      lastName
      legalName
      lineIdPc
      lineUserId
      maxComplexityPc
      middleName
      migratedToFlightPath
      name
      nationalId
      nextAppointmentDatePc
      nicknamePc
      noOfRetainersPurchased
      numberOfOpportunities
      ownerId
      ownerName
      ownerPhoneNumberWOPlusSignPc
      parentId
      parentName
      patientMainConcernPc
      personBirthdate
      personContactId
      personDoNotCall
      personEmailBouncedDate
      personEmailBouncedReason
      personGenderIdentity
      personHasOptedOutOfEmail
      personHomePhone
      personLastCURequestDate
      personLastCUUpdateDate
      personLeadSource
      personMailingAddress
      personMailingCity
      personMailingCountry
      personMailingCountryCode
      personMailingGeocodeAccuracy
      personMailingLatitude
      personMailingLongitude
      personMailingPostalCode
      personMailingStreet
      personMobilePhone
      phone
      piUtmCampaignPc
      piUtmContentPc
      piUtmMediumPc
      piUtmSourcePc
      piUtmTermPc
      quoteCreationEnabled
      recentTreatmentPlan
      recordTypeId
      recordTypeName
      refinementCount
      retainerLost
      retainersFittingApptNotRequired
      roleAtClinicPc
      salutation
      secondaryEmailPc
      shippingAddress
      shippingCity
      shippingCountry
      shippingCountryCode
      shippingGeocodeAccuracy
      shippingLatitude
      shippingLongitude
      shippingPostalCode
      shippingStreet
      submittingForTheChild
      suffix
      surveysDisabled
      tags
      tagsPc
      templatizedPrescriptionBracesPc
      templatizedPrescriptionRefinementPc
      testRecord
      testRecordPc
      timeOfFirstPhoneCall
      timeOfLastPhoneCall
      toothsiPatient
      totalNumberOfCasesPc
      totalNumberOfReferralsPc
      type
      unhappyAboutPc
      website
      wechatIdPc
      whatsappConsentCheckboxPc
      whatsappNumberPc
      whiteningPrescriptionEnabled
      wonFirstOpportunity
      x18DigitIdAccount
      zaloIdPc
      zenchatMentionNotifDaysPc
      zenyumProDisplayId
    }
  }
`;

export const CREATE_SALESFORCE_ACCOUNT = gql`
  mutation createSalesforceAccount($input: SalesforceAccountInput!)
  @api(name: treatmentMonitor) {
    createSalesforceAccount(input: $input) {
      id
    }
  }
`;

export const UPDATE_SALESFORCE_ACCOUNT = gql`
  mutation updateSalesforceAccount($id: ID!, $input: SalesforceAccountInput!)
  @api(name: treatmentMonitor) {
    updateSalesforceAccount(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_SALESFORCE_ACCOUNT = gql`
  mutation deleteSalesforceAccount($id: ID!) @api(name: treatmentMonitor) {
    deleteSalesforceAccount(id: $id)
  }
`;

export const GET_SALESFORCE_ACCOUNT_HISTORY = gql`
  query getSalesforceAccountHistory($accountId: ID!)
  @api(name: treatmentMonitor) {
    getSalesforceAccountHistory(accountId: $accountId) {
      createdDate
      field
      fieldLabel
      createdBy
      newValue
      oldValue
    }
  }
`;
